module.exports = __webpack_public_path__ + "img/VAD.io_creatorj.9abcce80.png";